import { RouteLocationRaw } from "vue-router";
import router from "@/router";
import { useStore } from "@/store";

const store = useStore();

export default function goBackOrToRoute(
  route: RouteLocationRaw = "home"
): void {
  if (store.latestFromRoute.matched.length) {
    router.go(-1);
  } else {
    if (typeof route === "string") {
      route = { name: route };
    }

    router.push(route);
  }
}
